<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';

@Component({})
export default class HomeLabImage extends Vue {

}
</script>

<template>
  <div class="svg-container">

    <svg viewBox="0 0 1400 850" xmlns="http://www.w3.org/2000/svg" class="network-topology">
      <!-- Proxmox QEMU/KVM Layer (TOP CENTER) -->
      <g class="layer proxmox-layer">
        <rect x="560" y="30" width="280" height="100" rx="12" class="layer-bg" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-deep)" stroke-width="3"/>
        <text x="700" y="60" class="layer-title">{{ $t('homelab.svg.proxmoxTitle') }}</text>
        <text x="700" y="80" class="layer-subtitle">{{ $t('homelab.svg.proxmoxSubtitle') }}</text>
        <text x="700" y="100" class="layer-detail">{{ $t('homelab.svg.proxmoxDetail') }}</text>
      </g>

      <!-- K3s Master Nodes (3x with etcd) - BELOW PROXMOX -->
      <g class="node k3s-master">
        <rect x="200" y="180" width="180" height="110" rx="10" class="node-bg" fill="var(--ln-glass-surface)"
              stroke="var(--ln-teal-light)" stroke-width="2.5"/>
        <text x="290" y="210" class="node-title">{{ $t('homelab.svg.master') }} 1</text>
        <text x="290" y="230" class="node-detail">{{ $t('homelab.svg.etcd') }}</text>
        <text x="290" y="250" class="node-detail">{{ $t('homelab.svg.apiServer') }}</text>
        <text x="290" y="270" class="node-detail">{{ $t('homelab.svg.controller') }}</text>
      </g>
      <g class="node k3s-master">
        <rect x="610" y="180" width="180" height="110" rx="10" class="node-bg" fill="var(--ln-glass-surface)"
              stroke="var(--ln-teal-light)" stroke-width="2.5"/>
        <text x="700" y="210" class="node-title">{{ $t('homelab.svg.master') }} 2</text>
        <text x="700" y="230" class="node-detail">{{ $t('homelab.svg.etcd') }}</text>
        <text x="700" y="250" class="node-detail">{{ $t('homelab.svg.apiServer') }}</text>
        <text x="700" y="270" class="node-detail">{{ $t('homelab.svg.controller') }}</text>
      </g>
      <g class="node k3s-master">
        <rect x="1020" y="180" width="180" height="110" rx="10" class="node-bg" fill="var(--ln-glass-surface)"
              stroke="var(--ln-teal-light)" stroke-width="2.5"/>
        <text x="1110" y="210" class="node-title">{{ $t('homelab.svg.master') }} 3</text>
        <text x="1110" y="230" class="node-detail">{{ $t('homelab.svg.etcd') }}</text>
        <text x="1110" y="250" class="node-detail">{{ $t('homelab.svg.apiServer') }}</text>
        <text x="1110" y="270" class="node-detail">{{ $t('homelab.svg.controller') }}</text>
      </g>

      <!-- Kube VIP (virtual IP for API) - BELOW MASTERS -->
      <g class="service kube-vip">
        <rect x="530" y="340" width="340" height="70" rx="10" class="service-bg" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-deep)" stroke-width="3"/>
        <text x="700" y="370" class="service-title">{{ $t('homelab.svg.kubeVipTitle') }}</text>
        <text x="700" y="390" class="service-detail">{{ $t('homelab.svg.kubeVipDetail') }}</text>
      </g>

      <!-- MetalLB & Traefik - RIGHT SIDE -->
      <g class="service metallb">
        <rect x="950" y="340" width="240" height="70" rx="10" class="service-bg" fill="var(--ln-glass-surface)"
              stroke="var(--ln-stone-grey)" stroke-width="2.5"/>
        <text x="1070" y="365" class="service-title">MetalLB</text>
        <text x="1070" y="385" class="service-detail">L2 Load Balancing</text>
        <text x="1070" y="400" class="service-detail">IP Pool</text>
      </g>

      <g class="service traefik">
        <rect x="950" y="440" width="240" height="90" rx="10" class="service-bg" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-deep)" stroke-width="3"/>
        <text x="1070" y="470" class="service-title">Traefik Ingress</text>
        <text x="1070" y="490" class="service-detail">MetalLB IP</text>
        <text x="1070" y="510" class="service-detail">→ Internet</text>
      </g>

      <!-- Monitoring Stack -->
      <g class="monitoring-stack">
        <rect x="50" y="480" width="340" height="200" rx="12" class="layer-bg" fill="var(--ln-glass-base)"
              stroke="var(--ln-terracotta-subtle)" stroke-width="3"/>
        <text x="220" y="510" class="layer-title">Monitoring</text>

        <rect x="70" y="535" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-terracotta-subtle)"/>
        <text x="220" y="560" class="service-mini-text">Prometheus</text>

        <rect x="70" y="590" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-terracotta-subtle)"/>
        <text x="220" y="615" class="service-mini-text">Grafana</text>

        <rect x="70" y="645" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-terracotta-subtle)"/>
        <text x="220" y="670" class="service-mini-text">Loki</text>
      </g>

      <!-- CI/CD Stack -->
      <g class="cicd-stack">
        <rect x="430" y="480" width="340" height="200" rx="12" class="layer-bg" fill="var(--ln-glass-base)"
              stroke="var(--ln-teal-light)" stroke-width="3"/>
        <text x="600" y="510" class="layer-title">CI/CD & GitOps</text>

        <rect x="450" y="535" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-light)"/>
        <text x="600" y="560" class="service-mini-text">GitLab CI/CD</text>

        <rect x="450" y="590" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-light)"/>
        <text x="600" y="615" class="service-mini-text">ArgoCD</text>

        <rect x="450" y="645" width="300" height="40" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-teal-light)"/>
        <text x="600" y="670" class="service-mini-text">Registry</text>
      </g>

      <!-- Applications Layer -->
      <g class="apps-layer">
        <rect x="810" y="570" width="380" height="110" rx="12" class="layer-bg" fill="var(--ln-glass-base)"
              stroke="var(--ln-stone-grey)" stroke-width="3"/>
        <text x="1000" y="600" class="layer-title">Applications</text>

        <circle cx="880" cy="645" r="25" class="app-icon" fill="var(--ln-glass-elevated)" stroke="var(--ln-teal-deep)"
                stroke-width="2"/>
        <text x="880" y="652" class="app-icon-text">WA</text>

        <circle cx="970" cy="645" r="25" class="app-icon" fill="var(--ln-glass-elevated)" stroke="var(--ln-teal-deep)"
                stroke-width="2"/>
        <text x="970" y="652" class="app-icon-text">DB</text>

        <circle cx="1060" cy="645" r="25" class="app-icon" fill="var(--ln-glass-elevated)" stroke="var(--ln-teal-deep)"
                stroke-width="2"/>
        <text x="1060" y="652" class="app-icon-text">API</text>

        <circle cx="1150" cy="645" r="25" class="app-icon" fill="var(--ln-glass-elevated)" stroke="var(--ln-teal-deep)"
                stroke-width="2"/>
        <text x="1150" y="652" class="app-icon-text">...</text>
      </g>

      <!-- Storage & Security - BOTTOM ROW -->
      <g class="storage-layer">
        <rect x="50" y="720" width="560" height="110" rx="12" class="layer-bg" fill="var(--ln-glass-base)"
              stroke="var(--ln-stone-grey)" stroke-width="3"/>
        <text x="330" y="750" class="layer-title">Distributed Storage</text>

        <rect x="70" y="775" width="240" height="45" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-stone-grey)"/>
        <text x="190" y="803" class="service-mini-text">Longhorn CSI</text>

        <rect x="350" y="775" width="240" height="45" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-stone-grey)"/>
        <text x="470" y="803" class="service-mini-text">HA Replication</text>
      </g>

      <g class="security-layer">
        <rect x="650" y="720" width="540" height="110" rx="12" class="layer-bg" fill="var(--ln-glass-base)"
              stroke="var(--ln-terracotta-hover)" stroke-width="3"/>
        <text x="920" y="750" class="layer-title">Security & Network</text>

        <rect x="680" y="775" width="230" height="45" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-terracotta-hover)"/>
        <text x="795" y="803" class="service-mini-text">Cert-Manager</text>

        <rect x="940" y="775" width="230" height="45" rx="6" class="service-mini" fill="var(--ln-glass-elevated)"
              stroke="var(--ln-terracotta-hover)"/>
        <text x="1055" y="803" class="service-mini-text">Network Policies</text>
      </g>

      <!-- CLEAN CONNECTIONS - No overlaps -->
      <!-- Proxmox to Masters (vertical lines) -->
      <line x1="700" y1="130" x2="290" y2="180" class="connection" stroke="var(--ln-teal-deep)" stroke-width="2.5"
            stroke-dasharray="6,4">
        <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="700" y1="130" x2="700" y2="180" class="connection" stroke="var(--ln-teal-deep)" stroke-width="2.5"
            stroke-dasharray="6,4">
        <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
      </line>
      <line x1="700" y1="130" x2="1110" y2="180" class="connection" stroke="var(--ln-teal-deep)" stroke-width="2.5"
            stroke-dasharray="6,4">
        <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
      </line>

      <!-- Masters to Kube VIP (vertical) -->
      <line x1="290" y1="290" x2="630" y2="340" class="connection" stroke="var(--ln-teal-light)" stroke-width="2"/>
      <line x1="700" y1="290" x2="700" y2="340" class="connection" stroke="var(--ln-teal-light)" stroke-width="2"/>
      <line x1="1110" y1="290" x2="770" y2="340" class="connection" stroke="var(--ln-teal-light)" stroke-width="2"/>

      <!-- Masters to MetalLB -->
      <line x1="1110" y1="235" x2="1070" y2="340" class="connection" stroke="var(--ln-stone-grey)" stroke-width="2"/>

      <!-- MetalLB to Traefik (vertical) -->
      <line x1="1070" y1="410" x2="1070" y2="440" class="connection" stroke="var(--ln-teal-deep)" stroke-width="3"/>

      <!-- Traefik to Applications -->
      <line x1="1070" y1="530" x2="1000" y2="570" class="connection" stroke="var(--ln-teal-deep)" stroke-width="2"/>
    </svg>
  </div>
</template>

<style scoped>
.svg-container {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1rem;
}

.network-topology {
  width: 100%;
  height: auto;
  display: block;
}

/* SVG Styling */
.layer-bg {
  opacity: 0.95;
}

.node-bg, .service-bg, .service-mini {
  opacity: 0.9;
}

.layer-title {
  fill: var(--ln-text-primary);
  font-size: 20px;
  font-weight: 700;
  text-anchor: middle;
}

.layer-subtitle {
  fill: var(--ln-text-secondary);
  font-size: 14px;
  text-anchor: middle;
}

.layer-detail, .node-detail, .service-detail {
  fill: var(--ln-text-secondary);
  font-size: 12px;
  text-anchor: middle;
}

.node-title, .service-title {
  fill: var(--ln-text-primary);
  font-size: 16px;
  font-weight: 600;
  text-anchor: middle;
}

.service-mini-text {
  fill: var(--ln-text-primary);
  font-size: 13px;
  font-weight: 500;
  text-anchor: middle;
}

.app-icon {
  opacity: 0.9;
}

.app-icon-text {
  fill: var(--ln-text-primary);
  font-size: 14px;
  font-weight: 700;
  text-anchor: middle;
}

.connection {
  opacity: 0.7;
}

.topology-caption {
  text-align: center;
  margin-top: 0.5rem;
  color: var(--ln-text-secondary);
  font-size: 0.95rem;
  font-style: italic;
}

@media (max-width: 768px) {
  .svg-container {
    max-height: 400px;
  }
}
</style>